import type { IExtendedRouteObject } from "@routes/types.ts";
import { routes } from "@routes/routes.ts";

export const layoutRoutes: IExtendedRouteObject[] = routes;
